import React from "react";

export default function PlatformSpace(props) {
    const {height} = props;

    return (
        <div style={{height: height}}>&nbsp;</div>
    );
};